// extracted by css-extract-rspack-plugin
var _1 = "eJ3gy3fY6CI06laE";
export { _1 as "svgIconWrapper" }
// extracted by css-extract-rspack-plugin
var _1 = "eJ3gy3fY6CI06laE";
export { _1 as "svgIconWrapper" }
